var module = angular.module('octopusApp.tenants');

module.controller('TenantEditProjectDialogController', function ($scope, busy, $uibModalInstance, octopusRepository, project, environments) {
    var isLoading = $scope.isLoading = busy.create();
    $scope.projectName = project.Name;
    $scope.selected = {
        environmentIds: _.pluck(environments, 'Id')
    };

    isLoading.promise(octopusRepository.Progression.getProgression(project).then(function(progression) {
        $scope.availableEnvironments = progression.Environments;
    }));

    $scope.close = function () {
        $uibModalInstance.close();
    };

    $scope.save = function () {
        $uibModalInstance.close({
            environmentIds: $scope.selected.environmentIds
        });
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/controllers/tenant_edit_project_dialog_controller.js
// module id = 625
// module chunks = 1